import {Component} from '@angular/core';
import {LoaderService} from "./loader.service";

@Component({
    selector: 'app-loading-bar',
    templateUrl: './loading-bar.component.html',
    styleUrls: ['./loading-bar.component.scss'],
    standalone: false
})
export class LoadingBarComponent {

  constructor(public loaderService: LoaderService) { }

}
